import React, { CSSProperties, FC } from 'react';
import ListItem from '@material-ui/core/ListItem';
import styled, { css } from 'styled-components';
import * as tokens from '@utmost.co/utmost-design-tokens';
import { mergeClassNames } from '../../utils/cssClassNameHelper';
import { ActiveDiv } from '../ActiveDiv';
import { Uds } from '../../types';

export type MenuListItemProps = Uds<{
  children?: any;
  disabled?: boolean;
  selected?: boolean;
  style?: CSSProperties;
  className?: string;
  onClick?(e: React.MouseEvent): any;
  wrapperDataTest?: string;
  hasEndIcon?: boolean;
  tabIndex?: number;
}>;

const noop = () => {};

export const MenuListItem: FC<React.PropsWithChildren<MenuListItemProps>> = ({
  children,
  disabled,
  style,
  onClick = noop,
  selected,
  className,
  wrapperDataTest,
  hasEndIcon,
  tabIndex,
  ...rest
}) => {
  const clickHandler = (e: React.MouseEvent) => {
    if (disabled) {
      e.stopPropagation();
      e.preventDefault();
    } else {
      onClick(e);
    }
  };
  return (
    <ActiveDiv
      onClick={clickHandler}
      data-test={wrapperDataTest ?? 'menu-list-item'}
      $hideFocus
      role="listitem"
      tabIndex={-1}
    >
      <StyledMenuItem
        data-test={rest.dataTest}
        button
        disableRipple
        disabled={disabled}
        tabIndex={tabIndex}
        $hasEndIcon={hasEndIcon}
        className={mergeClassNames(className ?? '', {
          disabled,
          selected
        })}
        selected={selected}
        style={{ color: tokens.colorOnSurface, ...style }}
      >
        {children}
      </StyledMenuItem>
    </ActiveDiv>
  );
};

export default MenuListItem;

const StyledMenuItem = styled(ListItem)<{ $hasEndIcon?: boolean }>`
  ${({ $hasEndIcon }) => ($hasEndIcon ? withEndIconCss : undefined)}
`;

const withEndIconCss = css`
  && {
    justify-content: space-between;

    .MuiListItemIcon-root {
      justify-content: flex-end;
      margin-left: 8px;
    }
  }
`;
